<template>
  <v-data-table
    :items="fornecedores"
    :headers="headers"
    fixed-header
    hide-default-footer
    dense
    :height="`${height}px`"
    class="font-resp-tabela"
    loading-text="carregando fornecedores... aguarde."
    :items-per-page="-1"
  >
    <template #body.prepend v-if="carregando">
      <tr>
        <td colspan="2" class="pa-0" style="height: 5px">
          <v-progress-linear indeterminate color="#c54258" />
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import FornecedorAPI from "./../../../api/fornecedor.js";
import {logout} from "./../../../helpers/index.js";

export default {
  name: "ListaFornecedoresDoGrupoAnalise",
  props:  {
    id_grupo_analise: Number,
    height: {
      type: Number,
      default: 200
    },
    fornecedores_selecionados: Array
  },
  data: () => ({
    carregando: false,
    fornecedores: [],
    headers: [
      {text: 'ID', value: 'id_fornecedor'},
      {text: 'Fornecedor', value: 'razao_social'}
    ]
  }),
  beforeMount() {
    setTimeout(this.buscarFornecedores, 500)
  },
  watch: {
    fornecedores_selecionados(val) {
      if (val.length != this.fornecedores.length) {
        this.buscarFornecedores(false);
      }      
    }
  },
  methods: {
    buscarFornecedores(liberar_carregamento = true) {
      if (this.fornecedores.length > 0 && liberar_carregamento) return;

      this.carregando = true;

      FornecedorAPI.buscarGrupoAnalise(this.id_grupo_analise)
        .then(resposta => {
          const {token, grupo} = resposta.data;
          localStorage.token = token;
          this.fornecedores = grupo.fornecedores;
          this.carregando = false;
          this.$emit("fornecedores", this.fornecedores.map(fornecedor => fornecedor.id_fornecedor));
        })
        .catch(() => logout());
    }
  }
}
</script>

<style scoped>
</style>
